import React, { useEffect, useState } from 'react';
import columns from '../../../columns/tickets.jsx';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import { GetSupportTicketApi } from '../../../api/request/ib/support.js';
import { useSelector } from "react-redux";
import moment from 'moment';
import Eye from '../../../assets/Eye.jsx';
import { useNavigate } from 'react-router-dom';

export default function Support() {

    const { userDetails } = useSelector((state) => state.user);
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [sorter, setSorter] = useState({ SortBy: 'openDate', SortOrder: '' });

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'openDate', SortOrder: '' });
        }
    };


    const getColor = (priority) => {
        switch (priority) {
            case 'High':
                return '#ef6464';
            case 'Normal':
                return '#e7c553';
            case 'Low':
                return '#2d9b63';
        }
    }

    const getTickets = async () => {
        try {
            setIsLoading(true);
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                ...sorter,
            }
            const { data } = await GetSupportTicketApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(data?.data?.map((item) => {
                    return ({
                        ...item,
                        name: `${item?.firstName} ${item?.lastName}`,
                        createdAt: item?.openDate ? moment(item?.openDate).format('DD-MM-YYYY LT') : null,
                        priority: (<p className='uppercase font-bold text-sm' style={{ color: getColor(item?.priority) }}>{item?.priority}</p>),
                        status: (item?.status == 'Open' ? (<p className='uppercase font-bold text-[#2D9B63] text-sm'>{item?.status}</p>) : (<p className='uppercase font-bold text-[#ef6464] text-sm'>{item?.status}</p>)),
                        details: (<div className='cursor-pointer ' onClick={() => navigate(`/ib/view_ticket/${item?.ticketId}`)} src='/assets/icons/eye.svg' alt='icon' ><Eye /></div>),
                    })
                }));
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setData([]);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getTickets();
    }, [page, pageSize, sorter]);


    return (
        <div>
            <div className='border-[2px] border-light rounded-xl pt-4 w-full'>
                <div className='flex justify-between items-center px-4 lg:px-6 pb-4 border-b border-light'>
                    <p className='text-[#2F2B3D] text-xl font-semibold'>Ticket List</p>
                </div>
                <div className='my-6'>
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
                    <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>
        </div>
    )
}
